export const SEGMENT_DEBUG_LOGGER_ENABLED_COOKIE_KEY = 'SEGMENT_DEBUG_LOGGER_ENABLED';
